export const callFragmentsLimit = 10;

export const callTagsLimit = 10;
